export const profile = {
  name: "Vishakha Dhivar",
  firstName: "Vishakha",
  lastName: "Dhivar",
  title: "Public Health Researcher & Physician",
  roles: ["Research Associate", "Physician"],
  location: "England, United Kingdom",
  email: "drvishakhadhivar26@gmail.com",
  phone: "+44 7747 208587",
  phoneHref: "+447747208587",
  linkedin: "https://linkedin.com/in/dr-vishakha-dhivar",
  summary:
    "Public Health Researcher and Physician with a Master's from the University of Exeter, combining 4+ years of clinical experience with expertise in systematic reviews, evidence synthesis, and health policy analysis. Skilled in PRISMA-driven methodology, R-based data analysis, and Rayyan-assisted literature screening — adept at translating complex evidence into actionable public health recommendations.",
  objective:
    "Seeking a public health research role applying evidence synthesis expertise to advance health equity and policy.",
};

export const stats = [
  { value: "4+", label: "Years of clinical practice" },
  { value: "470+", label: "Hospital audits delivered" },
  { value: "2,200+", label: "Articles screened & synthesised" },
  { value: "77", label: "Clinicians led across 8 districts" },
];

export const marqueeItems = [
  "Public Health Research",
  "Evidence Synthesis",
  "Health Equity",
  "Systematic Reviews",
  "Clinical Governance",
  "Data-Driven Policy",
];

export const experience = [
  {
    role: "Research Associate",
    org: "University of Exeter",
    place: "England, UK",
    dates: "Apr 2026 — Present",
    current: true,
    points: [
      "Leading a PRISMA-guided systematic review on ethnicity-specific PSA reference ranges and prostate cancer diagnosis.",
      "Screening studies in Rayyan with blind review, AI-assisted prioritisation and PICO text mining; analysing and visualising data in R.",
      "Contributing to a parallel literature review on communication barriers autistic adults face when expressing pain.",
    ],
  },
  {
    role: "Public Health Research Associate",
    org: "Ensokea",
    place: "Remote",
    dates: "May 2025",
    current: false,
    points: [
      "Reviewed and synthesised current literature to identify key public health findings.",
      "Authored concise, evidence-based reports summarising research outcomes.",
    ],
  },
  {
    role: "General Physician",
    org: "Wazir Clinic",
    place: "Mumbai, India",
    dates: "Jan 2021 — Feb 2023",
    current: false,
    points: [
      "Delivered primary care to a diverse caseload, diagnosing and managing acute and chronic conditions.",
      "Championed patient education and preventive health initiatives; spearheaded community outreach and screening programmes.",
      "Coordinated with multidisciplinary teams to ensure continuity of care.",
    ],
  },
  {
    role: "Medical Officer",
    org: "Medi Assist Health Insurance",
    place: "Mumbai, India",
    dates: "Oct 2018 — Dec 2020",
    current: false,
    points: [
      "Directed 40 medical officers and 37 specialists across eight districts for two major government health insurance schemes (PMJAY, MJPJAY).",
      "Delivered 470+ hospital audits including NABH accreditation and infrastructure compliance reviews.",
      "Streamlined pre-authorisation and cashless claims, improving turnaround times for corporate clients.",
    ],
  },
];

export const projects = [
  {
    index: "01",
    title: "Ethnicity-specific PSA reference ranges & prostate cancer diagnosis",
    type: "Systematic Review · University of Exeter",
    year: "2026",
    tags: ["PRISMA", "Rayyan", "R", "PICO Text Mining"],
    blurb:
      "Evaluating how ethnicity-specific PSA thresholds could improve early detection, reduce misdiagnosis and tackle health inequalities.",
  },
  {
    index: "02",
    title: "Communication barriers autistic adults face when expressing pain",
    type: "Literature Review · University of Exeter",
    year: "2026",
    tags: ["Evidence Synthesis", "Rayyan", "Health Equity"],
    blurb:
      "Identifying challenges in pain expression, recognition and assessment to address communication-related inequalities in healthcare.",
  },
  {
    index: "03",
    title: "Interventions for young people with mental health disorders & comorbid substance use",
    type: "MPH Capstone · Scoping Review",
    year: "2024",
    tags: ["2,200+ Articles", "ANOVA", "GEE", "Regression"],
    blurb:
      "Evaluated CBT, motivational interviewing, family therapy and integrated care models — translating findings into policy recommendations.",
  },
  {
    index: "04",
    title: "Tackling malnutrition in Palghar's tribal communities",
    type: "MPH Research Project",
    year: "2024",
    tags: ["Policy", "Community Engagement", "Social Cognitive Theory"],
    blurb:
      "Investigated drivers of child undernutrition and designed multi-sectoral, policy-driven interventions with health and agriculture sectors.",
  },
  {
    index: "05",
    title: "National Polio Campaign",
    type: "Y.M.T. H.M.C. · Mumbai",
    year: "2018",
    tags: ["Immunisation", "Health Promotion"],
    blurb:
      "Administered OPV, monitored vaccination coverage and led citizen-facing vaccine awareness campaigns.",
  },
];

export const expertise = [
  {
    title: "Evidence Synthesis & Systematic Reviews",
    span: "md:col-span-2",
    tags: ["PRISMA Methodology", "Rayyan Screening", "AI-assisted Review", "PICO Text Mining", "Critical Appraisal", "Literature Screening"],
  },
  {
    title: "Data & Statistical Analysis",
    span: "md:col-span-2",
    tags: ["R Statistical Analysis", "Regression", "ANOVA", "GEE", "Effect-Size Analysis", "Data Visualisation", "Advanced Excel"],
  },
  {
    title: "Clinical & Public Health Practice",
    span: "md:col-span-2",
    tags: ["Primary Care", "Clinical Auditing", "NABH / Hospital Audits", "Clinical Coding", "Health Promotion", "Community Outreach"],
  },
  {
    title: "Leadership & Policy",
    span: "md:col-span-2",
    tags: ["Medical Team Leadership", "Healthcare Policy Analysis", "Stakeholder Engagement", "Programme Monitoring", "Claims Management", "Report Writing"],
  },
];

export const education = [
  {
    degree: "Master of Public Health (MPH)",
    school: "University of Exeter",
    place: "England, UK",
    year: "2023 — 2024",
  },
  {
    degree: "Bachelor of Homoeopathic Medicine & Surgery",
    school: "Maharashtra University of Health Sciences",
    place: "India",
    year: "2018",
  },
];

export const certifications = [
  { name: "Ethics Review of Health Research", issuer: "ICMR · NIE", year: "Jul 2025" },
  { name: "Scientific Writing in Health Research", issuer: "ICMR · NIE", year: "Jul 2025" },
  { name: "Clinical Coding & Medical Administration", issuer: "Certification", year: "Jul 2025" },
  { name: "Smoking Cessation Training", issuer: "NCSCT", year: "Jun 2025" },
];
